import { ChallengeQuestTypeEnum } from 'app/models';

export class ChallengeQuestTypeModel {
    public static ChallengeQuestTypeList: Array<any> = [
        { id: ChallengeQuestTypeEnum.GuaranteedEarnings, name: 'Guaranteed Earnings' },
        { id: ChallengeQuestTypeEnum.TimeBasedIncentives, name: 'Time-Based Incentives' }
    ];
}
